import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { DutyType } from './DutyType';
import { DutyDate } from './DutyDate';

export const Duty = types.compose(
  BaseEntity,
  types
    .model('Duty', {
      dutyId: types.identifierNumber,
      dutyTypeId: types.number,
      dutyDateId: types.number,
      dutyDate: DutyDate,
    })
    .views((self) => {
      return {
        get dutyType() {
          return resolveIdentifier(DutyType, self, self.dutyTypeId);
        },
      };
    })
    .actions((self) => {
      const setDutyTypeId = (dutyTypeId: number) => {
        self.dutyTypeId = dutyTypeId;
      };
      const setDutyDateId = (dutyDateId: number) => {
        self.dutyDateId = dutyDateId;
      };
      return {
        setDutyTypeId,
        setDutyDateId,
      };
    }),
);
